import templateUrl from 'emun.activity/activity-list.htm'
import controller from 'emun.activity/activity-list.controller'

let ActivityList = {
    bindings: {
        customer: '<?',
        prospect: '<?'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default ActivityList;